import { useMemo } from 'react';

/**
 * 退款单条抽屉宽度 — 80% 视口宽，最小 960（对齐 PrePayment drawerWidth）
 *
 * 合并前 CreateRefundModal 与 RefundDetailDrawer 各写一份相同的 useMemo，
 * 合并后抽为共享 Hook。
 */
export const useRefundDrawerWidth = (): number =>
  useMemo(() => {
    const width80 = window.innerWidth * 0.8;
    return width80 > 960 ? width80 : 960;
  }, []);
